// extracted by mini-css-extract-plugin
export default {"root":"dgKFF","button":"_1Rx8P","is-active":"_1ZCKC","isActive":"_1ZCKC"};